/* ==========================================================================
   StackLabDesigns — global storefront JS
   Cart drawer, AJAX add-to-cart, qty steppers, accordions, form success.
   Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  "use strict";

  const routes = window.routes || {};
  const money = (cents) =>
    "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");

  /* ----------------------------------------------------------- cart drawer */
  const drawer = document.getElementById("CartDrawer");
  const openDrawer = () => {
    if (!drawer) { window.location.href = routes.cart_url || "/cart"; return; }
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open");
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
  };
  window.SLD = window.SLD || {};
  window.SLD.openCart = openDrawer;
  window.SLD.closeCart = closeDrawer;

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-cart-open]")) {
      // Only intercept when JS cart drawer exists
      if (drawer) { e.preventDefault(); openDrawer(); }
    }
    if (e.target.closest("[data-cart-close]") || e.target.matches(".cart-drawer__overlay")) {
      closeDrawer();
    }
    // Close the mobile nav drawer (native <details>) via overlay tap or close button
    if (e.target.closest("[data-burger-close]")) {
      const burger = document.querySelector("[data-header-burger]");
      if (burger) burger.removeAttribute("open");
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });

  /* --------------------------------------------------------- cart refresh */
  async function refreshCart() {
    try {
      const res = await fetch(`${routes.cart_url || "/cart"}?section_id=cart-drawer`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, "text/html");
      const fresh = html.querySelector("#CartDrawer .cart-drawer__inner");
      const current = document.querySelector("#CartDrawer .cart-drawer__inner");
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (err) { /* noop */ }
    updateCartCount();
  }

  async function updateCartCount() {
    try {
      const res = await fetch(`${routes.cart_url || "/cart"}.js`);
      const cart = await res.json();
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle("is-empty", cart.item_count === 0);
      });
    } catch (err) { /* noop */ }
  }
  window.SLD.refreshCart = refreshCart;

  /* ---------------------------------------------------- AJAX add to cart */
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector("[data-add-to-cart]");
    const original = btn ? btn.textContent : "";
    if (btn) { btn.setAttribute("disabled", "true"); btn.textContent = "Adding…"; }

    const formData = new FormData(form);
    formData.set("sections", "cart-drawer");
    try {
      const res = await fetch(routes.cart_add_url || "/cart/add", {
        method: "POST",
        headers: { Accept: "application/javascript" },
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        if (btn) { btn.removeAttribute("disabled"); btn.textContent = data.message || "Unavailable"; }
        return;
      }
      if (btn) {
        btn.textContent = "Added to cart ✓";
        btn.classList.add("is-added");
        setTimeout(() => { btn.removeAttribute("disabled"); btn.textContent = original; btn.classList.remove("is-added"); }, 2200);
      }
      await refreshCart();
      openDrawer();
    } catch (err) {
      if (btn) { btn.removeAttribute("disabled"); btn.textContent = original; }
    }
  });

  /* --------------------------------------------- line item qty + remove */
  document.addEventListener("click", async (e) => {
    const line = e.target.closest("[data-line]");
    if (!line) return;
    const key = line.getAttribute("data-line-key");
    const stepUp = e.target.closest("[data-line-plus]");
    const stepDown = e.target.closest("[data-line-minus]");
    const remove = e.target.closest("[data-line-remove]");
    if (!stepUp && !stepDown && !remove) return;
    e.preventDefault();

    const qtyEl = line.querySelector("[data-line-qty]");
    let qty = parseInt(qtyEl ? qtyEl.textContent : "1", 10) || 1;
    if (stepUp) qty += 1;
    if (stepDown) qty -= 1;
    if (remove) qty = 0;

    try {
      const res = await fetch(routes.cart_change_url || "/cart/change", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      await res.json();
      await refreshCart();
    } catch (err) { /* noop */ }
  });

  /* ------------------------------------------------ generic qty stepper */
  document.addEventListener("click", (e) => {
    const wrap = e.target.closest("[data-qty]");
    if (!wrap) return;
    const input = wrap.querySelector("input");
    if (!input) return;
    if (e.target.closest("[data-qty-plus]")) input.value = (parseInt(input.value, 10) || 1) + 1;
    if (e.target.closest("[data-qty-minus]")) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------------------------------------------------- accordions */
  document.addEventListener("click", (e) => {
    const head = e.target.closest("[data-accordion-head]");
    if (!head) return;
    const item = head.closest(".accordion__item");
    const body = item.querySelector(".accordion__body");
    const icon = head.querySelector(".accordion__icon");
    const isOpen = item.classList.toggle("is-open");
    if (body) body.hidden = !isOpen;
    if (icon) icon.textContent = isOpen ? "−" : "+";
    head.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });

  /* ---------------------------------------------------- contact-form success */
  // When a {% form 'contact' %} posts back with ?contact_posted=true, scroll to + reveal success.
  if (window.location.search.indexOf("contact_posted=true") !== -1) {
    const success = document.querySelector("[data-form-success]");
    if (success) {
      success.hidden = false;
      const form = document.querySelector("[data-form-fields]");
      if (form) form.hidden = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  /* --------------------------------------------------- image uploader */
  document.querySelectorAll("[data-uploader]").forEach((u) => {
    const input = u.querySelector("[data-upload-input]");
    const cta = u.querySelector("[data-upload-cta]");
    const status = u.querySelector("[data-upload-status]");
    const urlField = u.querySelector("[data-upload-url]");
    const cloud = u.getAttribute("data-cloud");
    const preset = u.getAttribute("data-preset");
    if (!input || !cloud || !preset) return;

    input.addEventListener("change", async () => {
      const file = input.files && input.files[0];
      if (!file) return;
      if (file.size > 10 * 1024 * 1024) {
        status.hidden = false;
        status.textContent = "That image is over 10MB — please pick a smaller one.";
        status.classList.add("is-error");
        return;
      }
      status.hidden = false;
      status.classList.remove("is-error");
      status.textContent = "Uploading…";
      if (cta) cta.querySelector("span").textContent = "Uploading…";

      const fd = new FormData();
      fd.append("file", file);
      fd.append("upload_preset", preset);
      try {
        const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud}/upload`, {
          method: "POST",
          body: fd,
        });
        const data = await res.json();
        if (data.secure_url) {
          urlField.value = data.secure_url;
          u.classList.add("is-uploaded");
          status.textContent = "✓ " + file.name + " uploaded";
          if (cta) cta.querySelector("span").textContent = "Change image";
        } else {
          throw new Error("no url");
        }
      } catch (err) {
        status.classList.add("is-error");
        status.textContent = "Upload failed — please try again or describe it in the message.";
        if (cta) cta.querySelector("span").textContent = "Click to upload an image";
      }
    });
  });

  /* init */
  updateCartCount();
})();
